<div class="convert-opp-to-lead-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <h2 mat-dialog-title>Convert {{environment.titleOpportunity}} to {{environment.titleLead}}</h2>
    </div>
    <button mat-icon-button class="close-button" [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="mat-typography">
    <div class="form-container">

      <!-- Contact Selection -->
      <nb-card class="nb-card">
        <nb-card-body fxLayout="column" fxLayoutAlign="start start" style="overflow-y: hidden">
          <div class="d-flex align-items-center justify-content-between w-100 mb-2">
            <div class="d-flex align-items-center" style="gap: 8px;">
              <span style="font-weight: 600; font-size: 15px; color: #1e293b;">Select Contacts</span>
              <span class="badge-count"
                *ngIf="!isLoadingContacts">{{selectedContacts.length}}/{{contactItems.length}}</span>
            </div>
            <mat-checkbox color="primary" *ngIf="contactItems.length > 0" [checked]="isAllSelected"
              (change)="toggleAll($event.checked)">
              Select All
            </mat-checkbox>
          </div>

          <p class="text-muted" style="font-size: 12px; margin: 0 0 12px 0;">
            Each selected contact will be created / updated as one {{environment.titleLead}}.
          </p>

          <!-- Loading -->
          <div class="contact-list-table loading-table w-100" *ngIf="isLoadingContacts">
            <div class="table-header">
              <div class="th-check"></div>
              <div class="th-col">First Name</div>
              <div class="th-col">Last Name</div>
              <div class="th-col">Email</div>
              <div class="th-col">Phone</div>
            </div>
            <div class="table-body">
              <div class="table-row" *ngFor="let s of [1,2,3]">
                <div class="td-check">
                  <div class="sk-box"></div>
                </div>
                <div class="td-col">
                  <div class="sk-line w-70"></div>
                </div>
                <div class="td-col">
                  <div class="sk-line w-70"></div>
                </div>
                <div class="td-col">
                  <div class="sk-line w-100"></div>
                </div>
                <div class="td-col">
                  <div class="sk-line w-70"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Contact list table -->
          <div class="contact-list-table w-100" *ngIf="!isLoadingContacts && contactItems.length > 0">
            <div class="table-header">
              <div class="th-check"></div>
              <div class="th-col">First Name</div>
              <div class="th-col">Last Name</div>
              <div class="th-col">Email</div>
              <div class="th-col">Phone</div>
            </div>
            <div class="table-body">
              <div class="table-row" *ngFor="let item of contactItems" [class.selected]="item.selected"
                (click)="toggleContact(item)">
                <div class="td-check">
                  <mat-checkbox color="primary" [checked]="item.selected" (click)="$event.stopPropagation()"
                    (change)="toggleContact(item)">
                  </mat-checkbox>
                </div>
                <div class="td-col">
                  <span *ngIf="item.contactName; else noFirstName">{{item.contactName}}</span>
                  <ng-template #noFirstName><span class="text-muted">-</span></ng-template>
                  <span *ngIf="item.isExistLead" class="exist-badge"
                    matTooltip="Matching {{environment.titleLead}} exists - will be updated">
                    <mat-icon>autorenew</mat-icon> Update
                  </span>
                </div>
                <div class="td-col">
                  <span *ngIf="item.contactLastName; else noLastName">{{item.contactLastName}}</span>
                  <ng-template #noLastName><span class="text-muted">-</span></ng-template>
                </div>
                <div class="td-col">
                  <span *ngIf="item.contactEmail; else noEmail">{{item.contactEmail}}</span>
                  <ng-template #noEmail><span class="text-muted">-</span></ng-template>
                </div>
                <div class="td-col">
                  <span *ngIf="item.contactPhone; else noPhone">{{item.contactPhone}}</span>
                  <ng-template #noPhone><span class="text-muted">-</span></ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty -->
          <div class="empty-state w-100" *ngIf="!isLoadingContacts && contactItems.length === 0">
            <mat-icon>person_off</mat-icon>
            <p>No contacts found in this {{environment.titleOpportunity}}</p>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- Lead Properties -->
      <nb-card class="nb-card" *ngIf="!isLoadingContacts && contactItems.length > 0">
        <nb-card-body fxLayout="column" fxLayoutAlign="start start" style="overflow-y: hidden">
          <div style="font-weight: 600; margin-bottom: 16px; font-size: 15px; color: #1e293b;">{{environment.titleLead}}
            Properties</div>

          <div class="row w-100">
            <div class="col-12 col-md-6">
              <app-dynamic-content-form style="width: 100%" [searchArrayAPI]="dynamicContentLeadSourceAPI"
                label="Lead Source" appearance="outline" [displayKey]="'content'" [control]="leadSourceCtrl">
              </app-dynamic-content-form>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Lead Interest</mat-label>
                <mat-select [(value)]="submitModel.leadInterest" panelClass="interest-panel"
                  matTooltip="Lead Interest / Temperature">
                  <mat-select-trigger>
                    <div style="display: flex; align-items: center;">
                      <span class="interest-dot"
                        [style.background-color]="getLeadInterestColor(submitModel.leadInterest)"></span>
                      <span>{{submitModel.leadInterest}}</span>
                    </div>
                  </mat-select-trigger>
                  <mat-option *ngFor="let option of leadInterestOptions" [value]="option">
                    <div style="display: flex; align-items: center;">
                      <span class="interest-dot" [style.background-color]="getLeadInterestColor(option)"></span>
                      <span>{{option}}</span>
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Tags</mat-label>
                <input matInput [(ngModel)]="tagsInput" (ngModelChange)="onTagsChange()"
                  placeholder="tag1, tag2, tag3" />
                <mat-hint>Separate tags with commas</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false" [disabled]="isLoading">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="selectedContacts.length === 0 || isLoading"
      [nbSpinner]="isLoading" nbSpinnerStatus="control" (click)="onSubmitClicked()">
      <mat-icon *ngIf="!isLoading">autorenew</mat-icon>
      Convert {{selectedContacts.length > 0 ? selectedContacts.length : ''}} to {{environment.titleLead}}
    </button>
  </mat-dialog-actions>
</div>